/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserWeeklyScheduleExceptionsControllerDelete$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;

/**
 * Creation timestamp of the exception
 */
  createdAt: string;
}

export function userWeeklyScheduleExceptionsControllerDelete(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleExceptionsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleExceptionsControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
    rb.path('createdAt', params.createdAt, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userWeeklyScheduleExceptionsControllerDelete.PATH = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}/{createdAt}';
